module.exports = __webpack_public_path__ + "static/media/zhanhuoLogo.e8a1a5e0.png";